export const GooglePlay = () => (
  <svg
    width="113"
    height="33"
    viewBox="0 0 113 33"
    fill="none"
    aria-label="Download from Google Play"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M108.19 0.819154C110.11 0.819154 111.673 2.34092 111.673 4.21107V28.4462C111.673 30.3163 110.11 31.8381 108.19 31.8381H4.50177C2.58146 31.8381 1.01889 30.3163 1.01889 28.4462V4.21107C1.01889 2.34092 2.58146 0.819154 4.50177 0.819154H108.19ZM108.19 0.171875H4.50177C2.22167 0.171875 0.354248 1.99052 0.354248 4.21107V28.4462C0.354248 30.6667 2.22167 32.4854 4.50177 32.4854H108.19C110.47 32.4854 112.338 30.6667 112.338 28.4462V4.21107C112.338 1.99052 110.47 0.171875 108.19 0.171875Z"
      fill="currentColor"
    />
    <path
      d="M39.6334 8.44629C39.6334 9.12083 39.4263 9.66108 39.0183 10.064C38.5493 10.5416 37.9384 10.7819 37.1897 10.7819C36.4742 10.7819 35.8633 10.5375 35.3621 10.0559C34.86 9.56716 34.6094 8.96734 34.6094 8.24938C34.6094 7.53141 34.86 6.93159 35.3621 6.44689C35.8633 5.96118 36.4742 5.7168 37.1897 5.7168C37.5459 5.7168 37.8855 5.7885 38.2096 5.92179C38.5327 6.0561 38.7957 6.23786 38.9862 6.46203L38.5534 6.88817C38.221 6.50546 37.7686 6.31662 37.1897 6.31662C36.6678 6.31662 36.2154 6.49435 35.8312 6.85283C35.4512 7.21231 35.2607 7.67783 35.2607 8.24938C35.2607 8.82092 35.4512 9.29048 35.8312 9.64997C36.2154 10.0044 36.6678 10.1861 37.1897 10.1861C37.7437 10.1861 38.2097 10.0044 38.5772 9.64593C38.8195 9.40862 38.9573 9.08145 38.9935 8.66339H37.1897V8.07973H39.5961C39.6251 8.20596 39.6334 8.32814 39.6334 8.44629Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M43.4511 6.42289H41.1907V7.95778H43.2285V8.54144H41.1907V10.0763H43.4511V10.6711H40.5508V5.82812H43.4511V6.42289Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M46.1446 10.6711H45.5047V6.42289H44.1182V5.82812H47.5321V6.42289H46.1446V10.6711Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M50.0029 10.6711V5.82812H50.6411V10.6711H50.0029Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M53.4743 10.6711H52.8396V6.42289H51.448V5.82812H54.866V6.42289H53.4743V10.6711Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M61.3293 10.0478C60.8396 10.5375 60.2328 10.7819 59.5089 10.7819C58.781 10.7819 58.1743 10.5375 57.6844 10.0478C57.1958 9.55908 56.9524 8.95926 56.9524 8.24938C56.9524 7.53949 57.1958 6.93967 57.6844 6.45093C58.1743 5.96118 58.781 5.7168 59.5089 5.7168C60.2286 5.7168 60.8353 5.96118 61.3251 6.45497C61.818 6.94775 62.0614 7.54353 62.0614 8.24938C62.0614 8.95926 61.818 9.55908 61.3293 10.0478ZM58.1577 9.64189C58.5263 10.0044 58.9746 10.1861 59.5089 10.1861C60.0391 10.1861 60.4916 10.0044 60.8561 9.64189C61.2237 9.27937 61.41 8.81385 61.41 8.24938C61.41 7.6849 61.2237 7.21938 60.8561 6.85687C60.4916 6.49435 60.0391 6.31259 59.5089 6.31259C58.9746 6.31259 58.5263 6.49435 58.1577 6.85687C57.7901 7.21938 57.6037 7.6849 57.6037 8.24938C57.6037 8.81385 57.7901 9.27937 58.1577 9.64189Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M62.9592 10.6711V5.82812H63.7358L66.1505 9.59466H66.1784L66.1505 8.66364V5.82812H66.7893V10.6711H66.1226L63.594 6.71876H63.566L63.594 7.65383V10.6711H62.9592Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.16"
      stroke-miterlimit="10"
    />
    <path
      d="M56.7947 17.7432C54.849 17.7432 53.2596 19.1873 53.2596 21.1796C53.2596 23.1558 54.849 24.6149 56.7947 24.6149C58.7444 24.6149 60.3338 23.1558 60.3338 21.1796C60.3338 19.1873 58.7444 17.7432 56.7947 17.7432ZM56.7947 23.2618C55.7271 23.2618 54.8087 22.4025 54.8087 21.1796C54.8087 19.9406 55.7271 19.0964 56.7947 19.0964C57.8622 19.0964 58.7847 19.9406 58.7847 21.1796C58.7847 22.4025 57.8622 23.2618 56.7947 23.2618ZM49.0815 17.7432C47.1318 17.7432 45.5465 19.1873 45.5465 21.1796C45.5465 23.1558 47.1318 24.6149 49.0815 24.6149C51.0302 24.6149 52.6166 23.1558 52.6166 21.1796C52.6166 19.1873 51.0302 17.7432 49.0815 17.7432ZM49.0815 23.2618C48.013 23.2618 47.0914 22.4025 47.0914 21.1796C47.0914 19.9406 48.013 19.0964 49.0815 19.0964C50.1491 19.0964 51.0676 19.9406 51.0676 21.1796C51.0676 22.4025 50.1491 23.2618 49.0815 23.2618ZM39.9033 18.7965V20.2566H43.4787C43.3742 21.0726 43.0945 21.6724 42.6658 22.0904C42.144 22.5953 41.3312 23.1558 39.9033 23.1558C37.7029 23.1558 35.98 21.424 35.98 19.2781C35.98 17.1323 37.7029 15.4005 39.9033 15.4005C41.093 15.4005 41.9586 15.8539 42.5976 16.4416L43.6527 15.4126C42.7591 14.5806 41.5704 13.9414 39.9033 13.9414C36.8859 13.9414 34.3501 16.3356 34.3501 19.2781C34.3501 22.2207 36.8859 24.6149 39.9033 24.6149C41.5341 24.6149 42.759 24.0939 43.7221 23.1164C44.7088 22.154 45.0163 20.8009 45.0163 19.7083C45.0163 19.369 44.9873 19.057 44.9355 18.7965H39.9033ZM77.4343 19.9284C77.1434 19.16 76.2457 17.7432 74.4171 17.7432C72.605 17.7432 71.0964 19.1358 71.0964 21.1796C71.0964 23.1043 72.5895 24.6149 74.591 24.6149C76.2094 24.6149 77.1434 23.6526 77.5276 23.0921L76.3265 22.3116C75.9257 22.8831 75.38 23.2618 74.591 23.2618C73.8072 23.2618 73.2449 22.9114 72.8845 22.2207L77.5969 20.3192L77.4343 19.9284ZM72.6298 21.0726C72.5895 19.7477 73.6849 19.0691 74.4698 19.0691C75.085 19.0691 75.6068 19.369 75.7808 19.7982L72.6298 21.0726ZM68.7997 24.4059H70.3487V14.3079H68.7997V24.4059ZM66.2628 18.5087H66.2111C65.8632 18.1068 65.1994 17.7432 64.3586 17.7432C62.5942 17.7432 60.981 19.2539 60.981 21.1907C60.981 23.1164 62.5942 24.6149 64.3586 24.6149C65.1994 24.6149 65.8632 24.2484 66.2111 23.8343H66.2628V24.3271C66.2628 25.6409 65.5432 26.3467 64.3825 26.3467C63.4361 26.3467 62.8489 25.6803 62.6066 25.1198L61.2595 25.6681C61.6478 26.579 62.676 27.6999 64.3825 27.6999C66.1987 27.6999 67.7311 26.6577 67.7311 24.1221V17.9523H66.2628V18.5087ZM64.4912 23.2618C63.4237 23.2618 62.53 22.3903 62.53 21.1907C62.53 19.9799 63.4237 19.0964 64.4912 19.0964C65.5432 19.0964 66.3727 19.9799 66.3727 21.1907C66.3727 22.3903 65.5432 23.2618 64.4912 23.2618ZM84.6867 14.3079H80.9818V24.4059H82.5267V20.5798H84.6867C86.4024 20.5798 88.0851 19.369 88.0851 17.4433C88.0851 15.5187 86.3983 14.3079 84.6867 14.3079ZM84.727 19.1751H82.5267V15.7125H84.727C85.8805 15.7125 86.5391 16.6466 86.5391 17.4433C86.5391 18.2249 85.8805 19.1751 84.727 19.1751ZM94.2771 17.7241C93.1608 17.7241 92.0001 18.2047 91.5227 19.2701L92.8937 19.8305C93.1888 19.2701 93.7314 19.0883 94.305 19.0883C95.1064 19.0883 95.9193 19.5579 95.9317 20.3869V20.4929C95.6522 20.3354 95.0537 20.1021 94.3174 20.1021C92.8409 20.1021 91.3364 20.8948 91.3364 22.3742C91.3364 23.7273 92.5458 24.5988 93.9054 24.5988C94.945 24.5988 95.5186 24.1413 95.8789 23.6092H95.9317V24.3897H97.4238V20.5162C97.4238 18.7258 96.0529 17.7241 94.2771 17.7241ZM94.0907 23.2578C93.5854 23.2578 92.8813 23.0134 92.8813 22.4025C92.8813 21.6209 93.7594 21.321 94.5194 21.321C95.1996 21.321 95.5186 21.4674 95.9317 21.6603C95.8105 22.5953 94.9853 23.2578 94.0907 23.2578ZM102.86 17.9452L101.084 22.3227H101.032L99.1954 17.9452H97.5294L100.288 24.0626L98.714 27.4666H100.328L104.579 17.9452H102.86ZM88.9342 24.4059H90.4831V14.3079H88.9342V24.4059Z"
      fill="currentColor"
    />
    <path
      d="M8.99792 6.2617C8.75459 6.51011 8.61377 6.89686 8.61377 7.39772V25.263C8.61377 25.7639 8.75459 26.1506 8.99792 26.3991L9.05798 26.4536L19.3234 16.4465V16.2102L9.05798 6.20312L8.99792 6.2617Z"
      fill="url(#paint0_linear_298_96)"
    />
    <path
      d="M22.7422 19.7841L19.3242 16.4467V16.2104L22.7463 12.873L22.8229 12.9165L26.8758 15.1653C28.0323 15.8035 28.0323 16.8537 26.8758 17.4959L22.8229 19.7407L22.7422 19.7841Z"
      fill="url(#paint1_linear_298_96)"
    />
    <path
      d="M22.8222 19.7402L19.3234 16.3281L8.9978 26.3988C9.38196 26.7927 10.0084 26.8401 10.7208 26.4463L22.8222 19.7402Z"
      fill="url(#paint2_linear_298_96)"
    />
    <path
      d="M22.8222 12.9167L10.7208 6.21068C10.0084 5.82089 9.38196 5.86835 8.9978 6.26217L19.3234 16.3288L22.8222 12.9167Z"
      fill="url(#paint3_linear_298_96)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_298_96"
        x1="18.412"
        y1="25.4491"
        x2="4.85882"
        y2="11.5516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A0FF" />
        <stop offset="0.0066" stop-color="#00A1FF" />
        <stop offset="0.2601" stop-color="#00BEFF" />
        <stop offset="0.5122" stop-color="#00D2FF" />
        <stop offset="0.7604" stop-color="#00DFFF" />
        <stop offset="1" stop-color="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_298_96"
        x1="28.3818"
        y1="16.3274"
        x2="8.338"
        y2="16.3274"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE000" />
        <stop offset="0.4087" stop-color="#FFBD00" />
        <stop offset="0.7754" stop-color="#FFA500" />
        <stop offset="1" stop-color="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_298_96"
        x1="20.9196"
        y1="14.4733"
        x2="2.54038"
        y2="-4.37295"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF3A44" />
        <stop offset="1" stop-color="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_298_96"
        x1="6.39865"
        y1="32.3433"
        x2="14.6058"
        y2="23.9277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#32A071" />
        <stop offset="0.0685" stop-color="#2DA771" />
        <stop offset="0.4762" stop-color="#15CF74" />
        <stop offset="0.8009" stop-color="#06E775" />
        <stop offset="1" stop-color="#00F076" />
      </linearGradient>
    </defs>
  </svg>
)
